export default __webpack_public_path__ + "static/media/Compass.c0df3c2c.svg";